import { redirect } from 'react-router-dom'
import AnonymousGuard from '@/components/guards/anonymous-guard'
import OrgAdminGuard from '@/components/guards/org-admin-guard'
import AccountPageGuard from '@/components/auth/AccountPageGuard'
import AdminDashboardPage from '@/organizations/views/AdminDashboardPage'
import SettingsPage from '@/routes/dashboard/settings/SettingsPage'
import MattersPage from '@/matter/components/MattersPage'
import type { RouteFactory } from '@/routing/types'
import ErrorPage from '@/components/error/error-page'

/**
 * Creates core dashboard routes for home, admin, account, settings, and matters.
 * These routes are direct children of the dashboard layout.
 * Note: Drive/files routes are now under matter-first routing (/dashboard/m/:matterId/files/...).
 */
export const createCoreRoutes: RouteFactory = () => [
  // Dashboard root redirects to matters table
  {
    path: '',
    loader: () => redirect('matters'),
  },
  {
    path: 'admin',
    element: (
      <AnonymousGuard>
        <OrgAdminGuard>
          <AdminDashboardPage />
        </OrgAdminGuard>
      </AnonymousGuard>
    ),
  },
  {
    path: 'account',
    element: <AccountPageGuard />,
  },
  {
    path: 'settings',
    element: (
      <AnonymousGuard>
        <SettingsPage />
      </AnonymousGuard>
    ),
  },
  {
    path: 'matters',
    element: (
      <AnonymousGuard>
        <MattersPage />
      </AnonymousGuard>
    ),
  },
  //-- ORGANIZATION DRIVE --//
  // deprecated route, redirect to error page
  {
    path: 'drives/org-drive/*',
    element: (
      <AnonymousGuard>
        <ErrorPage />
      </AnonymousGuard>
    ),
  },
]
